import React from "react";
import { createRoot } from "react-dom/client";
import { store } from "./redux/store";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import "./styles/react/app.scss";
import { Wrapper } from "./components";
require("bootstrap");

let a = window.location.toString().includes("/entry/");

let base =
  window.location.pathname.slice(0, 18) === "/qr-code-generator"
    ? window.location.pathname.slice(0, 18)
    : window.location.pathname.slice(0, 21);

const root = createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter basename={!a ? base : ""}>
    <Provider store={store}>
      <Wrapper />
    </Provider>
  </BrowserRouter>
);
